import React from 'react'

import { ArrowLeftOutlined } from '@ant-design/icons'
import { AutoComplete, Button, Form, Input } from 'antd'
import { Toaster } from 'react-hot-toast'
import { useEditarBachillerato } from '../../hooks/adminexamen/useEditarBachillerato'
import { Link } from 'react-router-dom'

export const EditarBachillerato = () => {

    const { onFinish, valoresForm, form, isLoading, opcionesLocalidades } = useEditarBachillerato()

    return (
        <>
            <Link to='/bachilleratos'>
                <Button type="link" shape="round" icon={<ArrowLeftOutlined />} size="middle">
                    Bachilleratos
                </Button>
            </Link>

            <Form
                form={ form }
                name="basic"
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 8,
                }}
                autoComplete="off"
                onFinish={ onFinish }
                initialValues={ valoresForm }
            >
                <Form.Item
                    label="Nombre"
                    name="nom_bachillerato"
                    rules={[
                    {
                        required: true,
                        message: 'Debes agregar un nombre.',
                    },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Localidad"
                    name="localidad"
                    rules={[
                    {
                        required: true,
                        message: 'Debes agregar una localidad',
                    },
                    ]}
                >
                    <AutoComplete
                        options={ opcionesLocalidades }
                        placeholder="input here"
                        filterOption={(inputValue, option) =>
                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }
                    />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 4
                    }}
                >
                    <Button type="primary" htmlType="submit" loading={ isLoading }>
                        Guardar
                    </Button>
                </Form.Item>
            </Form>
            <Toaster/>
        </>
    )
}
